import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../MilUnitList/Unit.module.css";
import viewStyles from "./BaseList.module.css";
import { faAngleDown, faAngleUp, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { axiosInstance } from "../../Helpers/axiosInstance";
import { BACKEND_URL } from "../../Helpers/constants";

const BaseListItem = ({ item, index, fetchBase, setIsModalOpen, setGroupingBases, unit, unitObj, base, setBase}) => {
  const [selectedBase, setSelectedBase] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  
  useEffect(() => {
    base?._id !== item._id ? setIsOpen(false) : setIsOpen(true)
  }, [base])
  
  const fetchBaseInfo  = async (base_id) => {
    if (!base_id) return; 
    try {
      if(base_id !== base?._id){
          let baseik = base_id
          const response = await axiosInstance.get(`/admin/base/${baseik}`);
          setBase(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching bases:", error);
    }
  };
  const removeBase = async (base_id) => {
    try {
        let baseik = base_id
        const confirm = window.confirm('Վստա՞հ եք, որ ցանկանում եք հեռացնել հենակետը')
        if(confirm){
          const response = await axiosInstance.delete(`admin/base/${baseik}`, {data: {milunit: unit}});
          if(response.data.status){
            setGroupingBases([...response.data.data])
          }
        }
      } catch (error) {
        console.error("Error fetching bases", )
    }
  }

  const upInTheList = async () => {
      const res = await axiosInstance.put('admin/bases-up', {index, milUnit: unit});
      if(res.data.status){
        setGroupingBases([...res.data.data])
      }
  }

  const downInTheList = async () => {
    const res = await axiosInstance.put('admin/bases-down', {index, milUnit: unit});
    if(res.data.status){
      setGroupingBases([...res.data.data])
    }
}


  const getBaseExcel = async () => {
      const res = await axiosInstance.get(`/admin/base-excel/${base._id}`)
      const { filePath } = res.data.data;

      const downloadLink = document.createElement("a");
      downloadLink.href = BACKEND_URL + filePath;
      downloadLink.download = "data.xlsx";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
  }

  const getBaseWord =  async () => {
      const res = await axiosInstance.get(`/admin/base-word/${base._id}`)
      const { filePath } = res.data.data;

      const downloadLink = document.createElement("a");
      downloadLink.href = BACKEND_URL + filePath;
      downloadLink.download = "data.xlsx";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
  }

  return (
    <div>
    <div>
      <div
        className={styles["editing-items"]}
        onClick={() => {setIsOpen(!isOpen); fetchBaseInfo(item._id)}}
      >
        <span className={styles["editing-item-info"]} >
          <p>{index + 1}.</p>
          <div className={styles["editing-item"]}>
            <span className={styles["editing-item-num"]}>{item.base_number}</span> 
            <span>{item.base_name}</span>
          </div>
        </span> 
        <div className={styles["items-controllers"]}>
          <div className={styles["move-items-div"]}>
              <FontAwesomeIcon icon={faAngleUp} className={styles["up"]} title="Բարձրացնել ցանկում" onClick={(e) => {e.stopPropagation();setIsOpen(false);upInTheList()}}/>
              <FontAwesomeIcon icon={faAngleDown} className={styles["down"]} title="Իջեցնել ցանկում" onClick={e => {e.stopPropagation();setIsOpen(false);downInTheList()}}/>
          </div>
          <FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել" onClick={(e) => {e.stopPropagation();setIsOpen(false);fetchBase(item._id); setIsModalOpen(true)}}/>
          <FontAwesomeIcon icon={faTrash} className={styles["remove"]} title="Ջնջել հենակետը" onClick={(e) => {e.stopPropagation();setIsOpen(false);removeBase(item._id)}}/>
        </div>
      </div>
      {base && base._id === item._id && isOpen && (<div className={viewStyles['base-main-information']}>
          <div className={viewStyles['base-main-tr']}>{`${item.base_number} մարտական դիրք (${base.base_cordinates}) ${base.base_cameraes ? "(Տեղադրված է համակցված տեսադիտարկման համակարգ)" : "" } ${base.base_company}ՀՎ հենակետ, պատասխանատու\` ${base.base_responsible}, մնալով ${base.base_responsible_location} մ/դ-ում `}</div>
          <div className={viewStyles['base-info-headers']}>
              <div className={viewStyles['per5']}>Հ/Հ</div>
              <div className={viewStyles['per10']}>Զինկո­չում</div>
              <div className={viewStyles['per5']}>Զ/կոչ</div>
              <div className={viewStyles['per20']}>Անուն, ազգանուն, հայրանուն</div>
              <div className={viewStyles['per15']}>Ստորաբաժանում</div>
              <div className={viewStyles['per15']}>Պաշտոնը</div>
              <div className={viewStyles['per10']}>Զենքի տեսակը</div>
              <div className={viewStyles['per10']}>Զենքի համարը</div>
              <div className={viewStyles['per10']}>Այլ տվյալներ</div>
          </div>
          <ol>
              {!!base.base_information.length && base.base_information.map((el, index) => 
                  <li key={index} className={`${viewStyles['base-info-headers']} ${viewStyles['base-info-list']}`}>
                      <p className={viewStyles['per5']}>{index + 1}.</p>
                      <p className={viewStyles['per10']}>{el.rang}</p>
                      <p className={viewStyles['per5']}>{el.conscription}</p>
                      <p className={viewStyles['per20']}>{el.full_name}</p>
                      <p className={viewStyles['per15']}>{el.subvision}</p>
                      <p className={viewStyles['per15']}>{el.position}</p>
                      <p className={viewStyles['per10']}>{el.gun_type}</p>
                      <p className={viewStyles['per10']}>{el.gun_number}</p>
                      <p className={viewStyles['per10']}>{el.other_information}</p>
                  </li>
              )}
          </ol>
          <div className="flex justify-end items-center mt-1 mb-3">
              <img src="/word.png" alt="word" title="Ստանալ ֆայլ հենակետերի համար" className="w-4 h-4 mr-2 cursor-pointer" onClick={getBaseWord}/>
              <img src="/excel.png" alt="excel" title="Ստանալ ֆայլ հենակետերի համար" className="w-4 h-4 cursor-pointer" onClick={getBaseExcel}/>
          </div>
      </div>)}
       
    </div>
 
    </div>
  );
};

export default BaseListItem;
